import { render, staticRenderFns } from "./cuslicencelWarnList.vue?vue&type=template&id=3b532805"
import script from "./cuslicencelWarnList.vue?vue&type=script&lang=js"
export * from "./cuslicencelWarnList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports